import { gql, useMutation, useQuery } from '@apollo/client'
import { useMemo } from 'react'

import {
  CancelResaleItemMutation,
  CancelResaleItemMutationVariables,
  ResaleDetailQuery,
  ResaleDetailQueryVariables,
  ResaleItemBoxFragmentDoc,
  UserBankAccountFragmentDoc,
} from '@/clients/utoniq-core/schema'
import { useMessage, useRouter } from '@/core'
import { makeViewModel } from '@/core/architecture'
import { setItemSku } from '@/core/sku'

import { Action, State } from './template'

/**
 *
 */
export const useViewModel = makeViewModel<State, Action>(() => {
  const { router } = useRouter<{ resaleItemId: string }>()
  const { showError } = useMessage()
  const resaleItemId = router.query.resaleItemId

  const { data, loading } = useQuery<
    ResaleDetailQuery,
    ResaleDetailQueryVariables
  >(QUERY, {
    variables: {
      id: resaleItemId,
    },
  })

  const [cancelResaleItem, { loading: submitting }] = useMutation<
    CancelResaleItemMutation,
    CancelResaleItemMutationVariables
  >(CANCEL_RESALE_ITEM)

  const resaleItem = useMemo(() => {
    if (!data?.resaleItem) {
      return null
    }
    return {
      ...data?.resaleItem,
      item: setItemSku(data?.resaleItem?.item, data.resaleItem.skuId),
    }
  }, [data?.resaleItem])

  return {
    state: {
      loading,
      submitting,
      resaleItem,
      user: data?.user,
    },
    actions: {
      async onCancelListing() {
        await cancelResaleItem({
          variables: {
            inputs: {
              resaleId: resaleItemId,
            },
          },
        }).catch(showError)
      },
    },
  }
})

const QUERY = gql`
  query ResaleDetail($id: ID!, $skuId: String) {
    resaleItem(id: $id) {
      ...ResaleItemBox
    }
    user {
      ...UserBankAccount
    }
  }
  ${ResaleItemBoxFragmentDoc}
  ${UserBankAccountFragmentDoc}
`

const CANCEL_RESALE_ITEM = gql`
  mutation cancelResaleItem($inputs: CancelResaleItemInput!, $skuId: String) {
    cancelResaleItem(inputs: $inputs) {
      ...ResaleItemBox
    }
  }
  ${ResaleItemBoxFragmentDoc}
`
